/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
export type ItemQuestionsFragment = {
  __typename: 'LocationItem'
  id: number
  item: {
    __typename: 'Item'
    id: number
    name: string
    hasSpecialInstructions: boolean
    description: string | null
    price: { __typename: 'Money'; formatted: string; cents: number }
    image: { __typename: 'ItemImage'; medium: string; high: string }
  }
  locationItemQuestions: Array<{
    __typename: 'LocationItemQuestion'
    id: number
    status: Types.LocationItemStatus
    text: string
    itemQuestion: {
      __typename: 'ItemQuestion'
      id: number
      text: string
      questionType: Types.ItemQuestionType
      questionTypeId: number
      required: boolean | null
      maxAnswers: number | null
    }
    locationItemAnswers: Array<{
      __typename: 'LocationItemAnswer'
      id: number
      status: Types.LocationItemStatus
      itemAnswer: {
        __typename: 'ItemAnswer'
        id: number
        active: boolean | null
        text: string | null
        default: boolean
        adjustment: {
          __typename: 'Money'
          cents: number
          formatted: string
        } | null
      }
    }> | null
  }>
}

export const ItemQuestionsFragment = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ItemQuestionsFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LocationItem' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasSpecialInstructions' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'medium' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'high' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationItemQuestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'active' }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itemQuestion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'questionType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'questionTypeId' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'required' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxAnswers' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationItemAnswers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'active' }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemAnswer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'default' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'adjustment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cents' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'formatted' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
